import { css } from 'styled-components';
import { theme } from '../../global';
import media from '../media';

const spacingValue = (prop) => {
	// If prop is not a boolean value we use that to set the property, otherwise use default spacing
	// Use cases: <Element margin="10rem" /> or <Element margin /> (Defaults to spacing)
	return (typeof (prop) !== 'boolean' && prop) || `${theme.spacing}rem`;
};

// Supplies the styled element with spacing options
// Examples:
// <Element paddingLeft="3rem" />
// <Element marginBottom />
// <Element padding="10rem 5rem" />
export const spacingOptions = css`
	${({ margin }) => margin && `margin: ${spacingValue(margin)}`}
	${({ marginBottom }) => marginBottom && `margin-bottom: ${spacingValue(marginBottom)}`}
	${({ marginTop }) => marginTop && `margin-top: ${spacingValue(marginTop)}`}
	${({ marginRight }) => marginRight && `margin-right: ${spacingValue(marginRight)}`}
	${({ marginLeft }) => marginLeft && `margin-left: ${spacingValue(marginLeft)}`}
	${({ padding }) => padding && `padding: ${spacingValue(padding)}`}
	${({ paddingBottom }) => paddingBottom && `padding-bottom: ${spacingValue(paddingBottom)}`}
	${({ paddingTop }) => paddingTop && `padding-top: ${spacingValue(paddingTop)}`}
	${({ paddingRight }) => paddingRight && `padding-right: ${spacingValue(paddingRight)}`}
	${({ paddingLeft }) => paddingLeft && `padding-left: ${spacingValue(paddingLeft)}`}
`;

export const lineHeightOptions = css`
	${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}`}
`;

export const fontSizeOptions = css`
	${({ fontSize }) => fontSize && `font-size: ${fontSize}`}
`;

export const backgroundColorOptions = css`
	${props => Object.keys(theme.colors).map((key) => {
	if(props.backgroundColor === key) {
		return `background-color: ${theme.colors[key]}`;
	}

	return null;
})}
`;

export const backgroundOptions = css`
	${props => Object.keys(theme.colors).map((key) => {
	if(props.background === key) {
		return `background: ${theme.colors[key]}`;
	}

	return null;
})}
`;

export const colorOptions = css`
	${props => Object.keys(theme.colors).map((key) => {
	if(props[key]) {
		return `color: ${theme.colors[key]}`;
	}

	return null;
})}
`;

export const sequencedAnimationDelay = (count, intensity) => {
	let value = '';

	for(let i = 1; i < count; ++i) {
		value += `&:nth-child(${i}) { animation-delay: ${(i - 1) * intensity}s; }`;
	}

	return css`${value}`;
};

export const sequencedTransitionDelay = (count, intensity) => {
	let value = '';

	for(let i = 1; i < count; ++i) {
		value += `&:nth-child(${i}) { transition-delay: ${(i - 1) * intensity}s; }`;
	}

	return css`${value}`;
};

export const clearButtonStyles = css`
	height: auto;
	background-color: transparent;
	color: ${({ theme: appTheme }) => appTheme.colors.gray};
	font-family: ${({ theme: appTheme }) => appTheme.fonts.fontFamily};
	font-size: ${({ theme: appTheme }) => appTheme.fonts.fontSize};
	line-height: ${({ theme: appTheme }) => appTheme.fonts.lineHeight};

	${media.tablet`
		font-size: ${({ theme: appTheme }) => appTheme.fonts.fontSizeTablet};
	`}

	${media.desktopSmall`
		font-size: ${({ theme: appTheme }) => appTheme.fonts.fontSizeDesktop};
		line-height: 3.4rem;
	`}
`;

export const withFancyScrollbar = css`
	&::-webkit-scrollbar {
		display: block;
		width: 4px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(0,0,0,.05);
	}

	&::-webkit-scrollbar-thumb {
		background: ${theme.colors.primary};
		border-radius: 100px;
	}
`;

export const withFancyHorizontalScrollbar = css`
	&::-webkit-scrollbar {
		display: block;
		height: 4px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(0,0,0,.05);
	}

	&::-webkit-scrollbar-thumb {
		background: ${theme.colors.primary};
		border-radius: 100px;
	}
`;
